import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullDateConverter',
  standalone: true
})
export class FullDateConverterPipe implements PipeTransform {


  transform(value: Date, args?: any): any {

    if (!value || !args) return;

    //en
    var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    //fa
    var faOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    var weekdayFaOption = { weekday: 'long', };

    //ar
    var hijriOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', era: 'short', calendar: 'islamic' };


    if (args === "fa")
      return `${value?.toLocaleDateString("fa-IR", weekdayFaOption as any)}
       ${value?.toLocaleDateString("fa-IR", faOptions as any)}`;

       else if (args === "ar") 
       return value?.toLocaleDateString("ar-SA", hijriOptions as any);
       
    else
      return value?.toLocaleDateString("en-US", options as any);





  }
}
